const ROOT = "imageViewer";
const SETTINGS_IMAGE_PREVIEW = "imagePreview";
const SETTINGS_ALT_INPUT_TEXT = "imageSettingsAltInput";
const SETTINGS_DISABLE_EXPAND_TOGGLE = "imageSettingsDisableExpandToggle";
const SETTINGS_DISABLE_DOWNLOAD_TOGGLE = "imageSettingsDisableDownloadToggle";
const SETTINGS_SPOILER_TOGGLE = "imageSettingsSpoilerToggle";
const EXPAND_BUTTON = "imageExpandButton";
export {
  EXPAND_BUTTON,
  ROOT,
  SETTINGS_ALT_INPUT_TEXT,
  SETTINGS_DISABLE_DOWNLOAD_TOGGLE,
  SETTINGS_DISABLE_EXPAND_TOGGLE,
  SETTINGS_IMAGE_PREVIEW,
  SETTINGS_SPOILER_TOGGLE
};
//# sourceMappingURL=dataHooks.js.map
